import { DatabaseValidation } from 'shared/types/validation';

import { contactsInputValidation } from './contacts';
import { deviceCalendarEventsInputValidation } from './deviceCalendarEvents';
import { entriesInputValidation } from './entries';
import { entryProceduresInputValidation } from './entryProcedures';
import { entryProductsInputValidation } from './entryProducts';
import { entryUsersInputValidation } from './entryUsers';
import { eventContactRemindersInputValidation } from './eventContactReminders';
import { eventContactsInputValidation } from './eventContacts';
import { eventHorsesInputValidation } from './eventHorses';
import { eventsInputValidation } from './events';
import { eventUsersInputValidation } from './eventUsers';
import { horseContactsInputValidation } from './horseContacts';
import { horsesInputValidation } from './horses';
import { inventoryChangesInputValidation } from './inventoryChanges';
import { inventoryProductsInputValidation } from './inventoryProducts';
import { invoiceInvoicingProductsInputValidation } from './invoiceInvoicingProducts';
import { invoicesInputValidation } from './invoices';
import { invoicingProductsInputValidation } from './invoicingProducts';
import { locationsInputValidation } from './locations';
import { onboardingsInputValidation } from './onboarding';
import { organisationAccountingsInputValidation } from './organisationAccountings';
import { organisationsInputValidation } from './organisations';
import { proceduresInputValidation } from './procedure';
import { productsInputValidation } from './product';
import { shoppingListsInputValidation } from './shoppingList';
import { shoppingListProductsInputValidation } from './shoppingListProduct';
import { userAnswersInputValidation } from './userAnswer';
import { usersInputValidation } from './users';
import { userSettingsInputValidation } from './userSettings';

export {
    createEntriesInputValidation,
    entriesInputValidation,
} from './entries';
export { createEventsInputValidation, eventsInputValidation } from './events';
export {
    createLocationsInputValidation,
    locationsInputValidation,
} from './locations';
export {
    createEventContactsInputValidation,
    eventContactsInputValidation,
} from './eventContacts';
export {
    createEventContactRemindersInputValidation,
    eventContactRemindersInputValidation,
} from './eventContactReminders';
export { createHorsesInputValidation, horsesInputValidation } from './horses';
export {
    createHorseContactsInputValidation,
    horseContactsInputValidation,
} from './horseContacts';
export {
    createEntryProductsInputValidation,
    entryProductsInputValidation,
} from './entryProducts';
export {
    createEntryProceduresInputValidation,
    entryProceduresInputValidation,
} from './entryProcedures';
export {
    createEntryUsersInputValidation,
    entryUsersInputValidation,
} from './entryUsers';
export {
    createEventUsersInputValidation,
    eventUsersInputValidation,
} from './eventUsers';
export {
    createEventHorsesInputValidation,
    eventHorsesInputValidation,
} from './eventHorses';
export {
    createInventoryProductsInputValidation,
    inventoryProductsInputValidation,
} from './inventoryProducts';
export {
    createInventoryChangesInputValidation,
    inventoryChangesInputValidation,
} from './inventoryChanges';
export {
    createOrganisationsInputValidation,
    organisationsInputValidation,
} from './organisations';
export {
    createOrganisationAccountingsInputValidation,
    organisationAccountingsInputValidation,
} from './organisationAccountings';
export {
    createInvoicesInputValidation,
    invoicesInputValidation,
} from './invoices';
export { createUsersInputValidation, usersInputValidation } from './users';
export {
    createDeviceCalendarEventsInputValidation,
    deviceCalendarEventsInputValidation,
} from './deviceCalendarEvents';
export {
    createContactsInputValidation,
    contactsInputValidation,
} from './contacts';
export {
    createInvoiceInvoicingProductsInputValidation,
    invoiceInvoicingProductsInputValidation,
} from './invoiceInvoicingProducts';

export const databaseValidation: DatabaseValidation = {
    events: eventsInputValidation,
    event_horses: eventHorsesInputValidation,
    horses: horsesInputValidation,
    entries: entriesInputValidation,
    entry_products: entryProductsInputValidation,
    entry_procedures: entryProceduresInputValidation,
    entry_users: entryUsersInputValidation,
    event_contacts: eventContactsInputValidation,
    event_contact_reminders: eventContactRemindersInputValidation,
    event_users: eventUsersInputValidation,
    locations: locationsInputValidation,
    horse_contacts: horseContactsInputValidation,
    inventory_products: inventoryProductsInputValidation,
    inventory_changes: inventoryChangesInputValidation,
    users: usersInputValidation,
    contacts: contactsInputValidation,
    organisations: organisationsInputValidation,
    organisation_accountings: organisationAccountingsInputValidation,
    invoices: invoicesInputValidation,
    invoice_invoicing_products: invoiceInvoicingProductsInputValidation,
    procedures: proceduresInputValidation,
    device_calendar_events: deviceCalendarEventsInputValidation,
    invoicing_products: invoicingProductsInputValidation,
    products: productsInputValidation,
    shopping_lists: shoppingListsInputValidation,
    shopping_list_products: shoppingListProductsInputValidation,
    onboardings: onboardingsInputValidation,
    user_answers: userAnswersInputValidation,
    user_settings: userSettingsInputValidation,
};
